const color = {
    50: '#FCDADA',
    300: '#F58F8F',
    400: '#EF4444',
    500: '#D73D3D',
    700: '#BF3636',
    900: '#A73030'
};
export default color;
